import { SegmentedToggle } from './SegmentedToggle';
import { sideLabel, type Side } from './partsRun';
import { useLanguage } from '../../contexts/LanguageContext';

// THE SWITCHES ABOUT WHAT THE PICTURE IS OF, top centre of the viewer: which hand of a pair, and
// whether the model's meshes stand assembled or spread apart. The same kind of control as the
// draw modes and here for the same reason — neither changes a byte of the file, and a control for
// a picture belongs on the picture.
//
// CENTRED ON THE VIEWPORT, and not tucked against the draw modes as the hand first was. Hung off
// those, it read as a second half of them — two joined rows in the top right, one about how the
// mesh is drawn and one about which object it IS, and the eye takes a pair of adjacent segmented
// rows as one control with four settings. In the middle each is plainly its own question.
//
// EACH ONLY WHERE IT HAS TWO TRUE POSITIONS: the hand where the part has two, the explosion where
// the model has two meshes or more. Over anything else a switch is a question the reader has to
// dismiss before believing the picture.
export function PoseToggles({ side, onSide, exploded, onExploded, inline = false }: {
  side?: Side;
  onSide: (side: Side) => void;
  exploded?: boolean;
  onExploded: (on: boolean) => void;
  // In a row of its own rather than over the viewport's top centre — see PartViewer's
  // `controlsAbove`.
  inline?: boolean;
}) {
  const { t, language } = useLanguage();
  if (side === undefined && exploded === undefined) return null;
  return (
    <div className={inline ? 'flex gap-2' : 'absolute left-1/2 top-3 z-10 flex -translate-x-1/2 gap-2'}>
      {exploded !== undefined && (
        <SegmentedToggle
          options={[
            { value: 'assembled' as Pose, label: t('notice.assembly.assembled') },
            { value: 'exploded' as Pose, label: t('notice.assembly.exploded') },
          ]}
          value={exploded ? 'exploded' : 'assembled'}
          onChange={(pose) => onExploded(pose === 'exploded')}
          className="shadow-sm"
        />
      )}
      {side !== undefined && (
        <SegmentedToggle
          options={[
            { value: 'left' as Side, label: sideLabel('left', language) },
            { value: 'right' as Side, label: sideLabel('right', language) },
          ]}
          value={side}
          onChange={onSide}
          className="shadow-sm"
        />
      )}
    </div>
  );
}

type Pose = 'assembled' | 'exploded';
